import {
  offMarketStatusCodes,
  hasListedPriceStatusCodes,
} from 'constants/listings/statusCodes';

export const isListingOffMarket = (statusCode: string): boolean =>
  offMarketStatusCodes.includes(statusCode);

export const hasListedPrice = (statusCode: string): boolean =>
  hasListedPriceStatusCodes.includes(statusCode);
